import { render, staticRenderFns } from "./contasBancarias.vue?vue&type=template&id=63d92276"
import script from "./contasBancarias.vue?vue&type=script&lang=js"
export * from "./contasBancarias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports